<template>
  <div>
    <div class="portal-version">v{{fleetData.version}}</div>
    <!-- test cards -->
    <div class="row">
        <div class="col-lg-5 col-sm-10" id="info">
          <div class="card card-one card-stats">
            <div class="card-body">
              <div class="actions-header row">
                <div class="col-1 col-md-2">
                    <div class="text-left type-icon"
                            :class="`text-${'light-gray'}`">
                        <img src="static/img/icons/dashboard.png"/>
                        <div class="event-amount-bubble text-center"><span>{{fleetData.data.contracts.filter(c => c.contractExpiring).length + fleetData.data.contracts.filter(c => c.mileageMissing).length + fleetData.data.contracts.filter(c => c.ticketInProgress).length}}</span></div>
                    </div>
                </div>
                <div class="col-2 col-md-4 text-uppercase text-bold text-left">{{ $t( "overview.info") }}</div>
              </div>
              <hr>
              <div class="row">
                <div class="col-lg-6 col-sm-12"><img class="img-slot" src="static/img/circular-info.png"/></div>
                <div class="col-lg-6 col-sm-12">
                  <div class="content row">
                    <div class="col-10">
                        <div class="content-deadlines text-left">
                            <div class="row card-up-contract">{{fleetData.data.contracts.filter(c => c.contractExpiring).length}}</div>
                            <div class="row text-uppercase card-down">{{ $t( "myFleet.contractExpiring") }}</div>
                        </div>
                    </div>
                    <div class="col-2">
                        <p-button class="action-button" aria-label="add button" type="default" round icon size="sm" :style="{ backgroundImage: `url(static/img/icons/button-action.png)` }" @click="goToFleetFilter('contractExpiring')"></p-button>
                    </div>
                    <hr class="w-100">
                  </div>
                  <div class="content row">
                    <div class="col-10">
                        <div class="content-deadlines text-left">
                            <div class="row card-up-mileage">{{fleetData.data.contracts.filter(c => c.mileageMissing).length}}</div>
                            <div class="row text-uppercase card-down">{{ $t( "myFleet.missingMileageRead") }}</div>
                        </div>
                    </div>
                    <div class="col-2">
                        <p-button class="action-button" aria-label="add button" type="default" round icon size="sm" :style="{ backgroundImage: `url(static/img/icons/button-action.png)` }" @click="goToFleetFilter('mileageMissing')"></p-button>
                    </div>
                    <hr class="w-100">
                  </div>
                  <div class="content row">
                    <div class="col-10">
                        <div class="content-deadlines text-left">
                            <div class="row card-up-tickets">{{fleetData.data.contracts.filter(c => c.ticketInProgress).length}}</div>
                            <div class="row text-uppercase card-down">{{ $t( "myFleet.activeTickets") }}</div>
                        </div>
                    </div>
                    <div class="col-2">
                        <p-button class="action-button" aria-label="add button" type="default" round icon size="sm" :style="{ backgroundImage: `url(static/img/icons/button-action.png)` }" @click="goToFleetFilter('ticketInProgress')"></p-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6"  id="termini">
            <actions-card-serviam
                type="deadlines"
                icon="Schedule.png"
                :events= eventsDeadlines()
                :total= getUniqueContracts()
                method= goToFleetFilterTerms
                :title="`${'termini'}`">
            </actions-card-serviam>
        </div>
        <div class="col-lg-3 col-sm-6" id="obavijesti">
          <div class="card card-one card-stats">
            <div class="card-body">
              <div class="actions-header row">
                <div class="col-1 col-md-2">
                    <div class="text-left type-icon"
                            :class="`text-${'light-gray'}`">
                        <img src="static/img/icons/Bell.png"/>
                        <div class="event-amount-bubble text-center"><span>{{messages.data.filter(message => !message.readOn).length}}</span></div>
                    </div>
                </div>
                <div class="col-4 col-md-8 text-uppercase text-bold text-left">{{ $t( "overview.news") }}</div>
              </div>
              <hr>
              <div class="row actions-body">
                <div class="col-lg-12 col-sm-12">
                  <div class="content" v-if="messages.loaded">
                    <div v-for="(message) in messages.data" :key="message._id" class="content-message" @click="showMessage(message._id)" >
                      <div class="agent-message">{{clearHtmlFromString(message.message)}}</div>
                      <div class="description">{{formatDate(message.sentOn, true)}}h - <span :class="`text-${message.readOn ? 'secondary' : 'success'}`">{{message.readOn ? $t( "overview.messageRead") : $t( "overview.messageNew")}}</span></div>
                      <hr class="w-100">
                    </div>
                  </div>
                  <div class="content" v-else>
                    {{ $t( "overview.noNews") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-0 col-sm-1"></div>
        <div class="col-lg-3 col-sm-6"  id="mojaFlota">
            <a class="no-a-hover-underline" href="/#/fleet">
              <stats-card-serviam
                  type="warning"
                  :small-title='$t("overview.numOfVehicles")'
                  :title="`${fleetData.data.contracts.length}`">
                  <div class="stats" slot="content-right">
                      <img class="img-slot" src="static/img/Flota_Passat_x3_2.png"/>
                  </div>
              </stats-card-serviam>
            </a>
        </div>
        <div class="col-lg-3 col-sm-6"  id="vozaci">
            <a class="no-a-hover-underline" href="/#/contacts">
             <stats-card-serviam
                type="warning"
                :small-title='$t("overview.drivers")'
                :title="`${contacts.length}`">
                <div class="stats" slot="content-right">
                    <div class="concentric-circles">
                        <div>
                            <span v-for="contact in contacts.slice(0, 6)" :key="contact.id" class="circle">{{`${contact.firstName && contact.firstName[0].toUpperCase() || ''}.${contact.lastName && contact.lastName[0].toUpperCase() || ''}`}}</span>
                        </div>
                    </div>
                </div>
             </stats-card-serviam>
            </a>
        </div>
        <div class="col-lg-3 col-sm-6"  id="noviNalog">
            <action-card-serviam
                type="warning"
                icon="Document.png"
                method="createNewOrder"
                title="novi nalog">
            </action-card-serviam>
        </div>
    </div>
  </div>

</template>

<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
  import {Badge, NewMileage, Card, StatsCard, StatsCardServiam, ActionCardServiam, ActionsCardServiam} from 'src/components/UIComponents';
  import LineChart from 'src/components/UIComponents/Charts/LineChart';
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue';
  import BarChart from 'src/components/UIComponents/Charts/BarChart'


  import {Table, TableColumn, Button} from 'element-ui'
  import swal from 'sweetalert2'


  import Vue from 'vue'
  Vue.use(Table)
  Vue.use(TableColumn)


  import moment from 'moment'
  import utils from 'src/util/common.js'
  import alerts from 'src/util/alerts.js'



  const vehiclesByTypeChartOptions = {
      scales: {
          yAxes: [{
              ticks: {
                  stepSize: 1,
                  beginAtZero: true
                }
          }]
      }
  };


  export default {
    components: {
      StatsCardServiam,
      ActionCardServiam,
      ActionsCardServiam,
      Card,
      StatsCard,
      ChartCard,
      Badge,
      LineChart,
      CircleChartCard,
      BarChart,
      [NewMileage.name]: NewMileage,
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        vehiclesByTypeChartOptions: vehiclesByTypeChartOptions,
        apiInProgress: false,
        newMileageModalActive: false,
        vehicleSelected: null,
        eventsNews: [
            {
                icon: 'fa fa-wrench',
                date: '22.10.2021',
                title: 'LOREM IPSUM1',
                description: '15 automobila lorem ipsum'
            },
            {
                icon: 'fa fa-dot-circle',
                date: '17.12.2021',
                title: 'LOREM IPSUM2',
                description: '15 automobila zamjeniti gume'
            },
            {
                icon: 'fa fa-user',
                date: '04.01.2022',
                title: 'LOREM IPSUM3',
                description: '4 nepročitane poruke'
            }
        ]

      }
    },
    mounted() {
      if (!this.$store.fleet.store.fleetData.loaded) this.$store.fleet.actions.getFleet();
      if (!this.$store.fleet.store.messages.loaded) this.$store.fleet.actions.getMessages();
      if (!this.$store.contacts.store.contacts.loaded) this.$store.contacts.actions.getContacts();

    },
    computed: {
        fleetData: function() { return this.$store.fleet.store.fleetData },
        messages: function() { return this.$store.fleet.store.messages },
        fleetMutations: function() { return this.$store.fleet.mutations },
        contacts: function() { return this.$store.contacts.mutations.getContactsFull() },
        dashNumbers: function() { return this.$store.contacts.mutations.getDashNumbers() },
        vehiclesByTypeChartData: function() {

            let setObject = {};
            let setArray = [];
            this.fleetData.data.contracts.forEach( ({auto}) => {
                let label = `${auto.autoManufacturer} ${auto.modelAndManufacturer ? auto.modelAndManufacturer.toLowerCase() : ''}`;
                let trimmed = label.trim().replace( /(^|\s)([a-z])/g , function(m,p1,p2){ console.log( [p1,p2] ); return p1+p2.toUpperCase(); } );;
                setObject[trimmed] = setObject[trimmed] ? setObject[trimmed] +1 : 1;
            });
            for (let key in setObject) {
                setArray.push({
                    name: key,
                    amount: setObject[key]
                })
            }
            setArray = setArray.sort( (a, b) => b.amount - a.amount);

            let randomColors = setArray.map( (type, i) => utils.getColorByIndex(i));


            return {
                labels: setArray.map( type => type.name),
                datasets: [
                    {
                        label: "Vehicles amount",
                        borderColor: randomColors,
                        fill: true,
                        backgroundColor: randomColors,
                        hoverBorderColor: randomColors,
                        borderWidth: 5,
                        data: setArray.map( type => type.amount),
                    }
                ]
            }
      },

    },
    methods: {
      clearHtmlFromString( val ) {
        val = val || '';
        return val.replace(/<[^>]+>/g, ' ');
      },
      num2money(value, points) {
        return utils.num2money(value, points)
      },
      formatDate(date, minutes) {
        if (!date) return '-';
        if (minutes) return moment(date).format('DD.MM.YYYY. HH:mm');
        return moment(date).format('DD.MM.YYYY');
      },
      formatInMillions(value) {
        return this.num2money(value/1000000)
      },
      formatInDecimals(value, decimals = 2) {
            value = isNaN(value) ? 0 : value;
            return JSON.parse(value.toFixed(decimals));
      },
      goToFinancialResults() {
        this.$router.push('/financials/results');
      },
      goToFinancialIncomePlan() {
        this.$router.push('/financials/income-plan');
      },
      getTopClients(data = []) {
        return data.map( (client, index) => {
          client.rank = index + 1;
          return client;
        })
      },
      getVehiclesNoMileage() {
        return;
        let filtered = this.fleetMutations.getFiltered('noMileage').sort( (a, b) => b.daysSinceLastReading - a.daysSinceLastReading);

        return filtered.map( (contract, index) => {
          return {
                id: contract.auto._id,
                rank: index + 1,
                registrationTable: contract.auto.registracijskeTablice,
                daysSinceLastReading: contract.daysSinceLastReading,
                lastDocumentedMileageDate: contract.mileage.lastDocumentedMileage ? moment(contract.mileage.lastDocumentedMileage.mileageDate.sec * 1000).toISOString() : null,
          }
        });

      },
      getVehiclesExtraMileage() {
        let filtered = this.fleetData.data.contracts.filter( (contract, index) => {
            let contractMileage = contract.najam.ugovorenaKilometraza ? parseInt(contract.najam.ugovorenaKilometraza) : null;
            let projectedFinalMileage = contract.mileage.projectedFinalMileage ? parseInt(contract.mileage.projectedFinalMileage) : null;
            if (!contractMileage || !projectedFinalMileage) return false;
            if (projectedFinalMileage > contractMileage) {
                contract.mileage.percentageMoreAtTheEnd = (projectedFinalMileage / contractMileage -1) * 100;
                return true
            }
        }).sort( (a, b) => b.mileage.percentageMoreAtTheEnd - a.mileage.percentageMoreAtTheEnd);

        return filtered.map( (contract, index) => {
          return {
                id: contract.auto._id,
                rank: index + 1,
                registrationTable: contract.auto.registracijskeTablice,
                daysSinceLastReading: contract.daysSinceLastReading,
                lastDocumentedMileageDate: contract.mileage.lastDocumentedMileage ? moment(contract.mileage.lastDocumentedMileage.mileageDate.sec * 1000).toISOString() : null,
                percentageMoreAtTheEnd: contract.mileage.percentageMoreAtTheEnd,
          }
        });

      },
      getNumOfMultipleDrivers() {
        let res = 0;
        for (let key in this.dashNumbers.drivers) {
            if (this.dashNumbers.drivers[key] > 1) res++;
        }
        return res;
      },
      openMileageModal(row) {
          this.newMileageModalActive = true;
          this.vehicleSelected = row.id;
      },
      goToNoMileageList() {
          this.fleetData.filterSelected = 'noMileage';
          this.$router.push('/fleet');
      },
      goToNoDriverList() {
          this.fleetData.filterSelected = 'noDriver';
          this.$router.push('/fleet');
      },
      goToTicketsActiveList() {
          this.fleetData.filterSelected = 'ticketsActive';
          this.$router.push('/fleet');
      },
      goToFleetFilter(filter) {
          this.fleetData.filterSelected = filter;
          this.$router.push('/fleet');
      },
      goToFleetFilterTerms(additionalFilter) {
          console.log('additionalFilter', additionalFilter);
          this.fleetData.filterSelected = 'terms';
          this.fleetData.filterSelectedAdditional = additionalFilter;
          this.fleetData.contractSelected = [];
          this.$router.push('/fleet');
      },

      createNewOrder() {
          this.fleetData.openNewTicket = true;
          this.$router.push('/fleet');
      },
      openEvent() {
        swal({
            title: 'TODO do something!',
            type: 'success'
        });
      },
      getUniqueContracts() {
        return this.fleetData.data.contracts.reduce((sum, contract) => { if (contract.registrationExpiring || contract.insuranceExpiring || contract.kaskoExpiring) { return sum +1} else return sum }, 0)
      },
      eventsDeadlines() {
        let registrationExpiring = this.fleetData.data.contracts.filter((contract) => contract.registrationExpiring).sort(function (a, b) { return b.auto.registrationEndDate - a.auto.registrationEndDate});
        let insuranceExpiring = this.fleetData.data.contracts.filter((contract) => contract.insuranceExpiring).sort(function (a, b) { return b.auto.istekOsig - a.auto.istekOsig});
        let kaskoExpiring = this.fleetData.data.contracts.filter((contract) => contract.kaskoExpiring).sort(function (a, b) { return b.auto.istekOsigk - a.auto.istekOsigk});

        return  [
            {
                date: registrationExpiring.length ? moment(registrationExpiring[0].auto.registrationEndDate).format('DD.MM.YYYY') : '-',
                title: 'REGISTRACIJA VOZILA',
                amount: registrationExpiring.length,
                action: 'registrationEndDate_raw'
            },
            {
                date: insuranceExpiring.length ? moment(insuranceExpiring[0].auto.istekOsig).format('DD.MM.YYYY') : '-',
                title: 'OSIGURANJE VOZILA',
                amount: insuranceExpiring.length,
                action: 'istekOsig_raw'
            },
            {
                date: kaskoExpiring.length ? moment(kaskoExpiring[0].auto.istekOsigk).format('DD.MM.YYYY') : '-',
                title: 'KASKO OSIGURANJE',
                amount: kaskoExpiring.length,
                action: 'istekOsigk_raw'
            }
        ]
      },
      showMessage(id) {
        let that = this;
        let message = that.messages.data.find(message => message._id == id);
				swal({
					title: message.message,
					text: `${that.formatDate(message.sentOn, true)}h`,
					type: 'info',
					showCancelButton: false,
					confirmButtonClass: 'btn btn-info btn-fill',
					confirmButtonText: that.$t('overview.markAsRead'),
					//cancelButtonClass: 'btn btn-fill',
          //cancelButtonText: that.$t('overview.back'),
          showConfirmButton: message.readOn ? false : true,
					buttonsStyling: false
				}).then( async function (res) {

          let respError;
          await that.$store.fleet.actions.markMessageAsRead(id).catch( (err) => { console.error('problemi;', err); respError = err;});
					if (respError) return alerts.error('');

          await that.$store.fleet.actions.getMessages();
					swal({
						title: that.$t('overview.markAsRead'),
						type: 'success',
						confirmButtonClass: 'btn btn-success btn-fill',
						buttonsStyling: false
					}).catch(err => {});
				}).catch(err => {})
      }
    }
  }

</script>
<style scoped>
    .card-one{
        min-height: 400px;
        max-height: 530px;
    }
    .card-category {
        font-weight: bold;
        text-transform: uppercase;
    }
    .card-title {
        font-size: 3em;
        font-style: italic;
    }
    .text-bold {
        font-weight: bold;
    }
    .text-light-gray {
        color: gray;
    }
    .action-text {
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 4px;
        font-size: 1.1em;
        text-shadow: 0px 1px, 1px 0px, 1px 1px;
    }
    .action-button {
      background-color: lightgray;
      color: black;
      background-position: center;
      border: 2px solid lightgray;
      background-size: cover;
      right: 10px;
    }
    .action-icon {
        margin-top: 60%;
        font-size: 2em;
        color: #d6752d;
    }
    .type-icon {
        font-size: 2em;
    }
    .event-amount-bubble {
        border-radius: 25px;
        width: 1em;
        height: 1em;
        position: absolute;
        top: -8px;
        background-color: #d6752d;
        left: 25px;
    }
    .event-amount-bubble span {
        font-size: 14px;
        position: relative;
        top: -12px;
        font-weight: bold;
        color: white;
    }
    .content-number {
        font-size: 1.5em;
        white-space: nowrap;
    }
    hr {
        margin-top: 0
    }
    .card-down {
      font-weight: bold;
    }
    .card-up-contract {
      font-size: 3em;
      color:#d6752d;
    }
    .card-up-mileage {
      font-size: 3em;
      color:gray;
    }
    .card-up-tickets {
      font-size: 3em;
      color:rgb(28, 63, 116);;
    }
    .content-message {
      cursor: pointer;
    }
    .agent-message {
      width: 90%;
      font-style: italic;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    #obavijesti .card {
      min-height: 400px;
      max-height: 400px;
    }
    #obavijesti .card-body {
      display: block;
      width: 100%;
      overflow-x: auto;
    }

    .no-a-hover-underline:hover {
      text-decoration: none;
    }


</style>
